export const useSellingItems = (registrationStore: any, user: any) => {
  const {
    sellingItemCategories,
    categoryActiveItems,
    loadSellingItems,
    unselectAllSellingItems,
    unselectAllEventTickets,
  } = registrationStore;

  return {
    sellingItemCategories,
    categoryActiveItems,
    loadSellingItems,
    unselectAllSellingItems,
    unselectAllEventTickets,
  };
}; 